"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _Search = _interopRequireDefault(require("@insided/shared/icons/Search"));

var _typeGuards = require("@insided/deprecated-libs/typeGuards");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DropdownSearchbox = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DropdownSearchbox, _Component);

  var _super = _createSuper(DropdownSearchbox);

  function DropdownSearchbox(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DropdownSearchbox);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "searchboxRef", null);

    _this.setState({
      value: ''
    });

    _this.onClear = _this.onClear.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(DropdownSearchbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.makeFocused();
    }
  }, {
    key: "makeFocused",
    value: function makeFocused() {
      var _this$searchboxRef;

      (_this$searchboxRef = this.searchboxRef) === null || _this$searchboxRef === void 0 ? void 0 : _this$searchboxRef.focus();
    }
  }, {
    key: "onInput",
    value: function onInput(event) {
      var _event$target;

      var input = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value;
      this.setState({
        value: input
      });
      this.props.onChange(this.props.items.filter(function (item) {
        return item.title.toLowerCase().includes(input.toLowerCase());
      }));
    }
  }, {
    key: "onClear",
    value: function onClear() {
      this.setState({
        value: ''
      });
      this.props.onChange(this.props.items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$searchPla = _this$props.searchPlaceholderText,
          searchPlaceholderText = _this$props$searchPla === void 0 ? 'Search' : _this$props$searchPla,
          _this$props$searchIco = _this$props.searchIconWidth,
          searchIconWidth = _this$props$searchIco === void 0 ? 24 : _this$props$searchIco,
          _this$props$searchIco2 = _this$props.searchIconHeight,
          searchIconHeight = _this$props$searchIco2 === void 0 ? 24 : _this$props$searchIco2;
      var value = this.state.value;
      return (0, _preact.h)("div", {
        className: "dropdown-searchbox"
      }, (0, _preact.h)(_Search.default, {
        width: searchIconWidth,
        height: searchIconHeight
      }), (0, _preact.h)("input", {
        className: "qa-dropdown-search-box",
        id: "searchbox",
        type: "text",
        placeholder: searchPlaceholderText,
        value: value,
        onInput: function onInput(e) {
          if ((0, _typeGuards.hasValueInEventTarget)(e)) {
            _this2.onInput(e);
          }
        },
        ref: function ref(searchbox) {
          _this2.searchboxRef = searchbox;
        }
      }), value && (0, _preact.h)(_Close.default, {
        className: "btn-clear-searchbox",
        onClick: function onClick(event) {
          event.stopPropagation();

          _this2.onClear();
        }
      }));
    }
  }]);
  return DropdownSearchbox;
}(_preact.Component);

var _default = DropdownSearchbox;
exports.default = _default;